export enum CSVTermListUploadMode {
  checkDuplicate = 0,
  ignore = 1,
  overrite = 2,
  saveWithoutDuplicated = 3,
}
